import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { Card, CardHeader, CardTitle, CardBody, Alert, Button } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { getLoggedUser } from '../../modules/User/UserActions';
import { getInstitutionsForLoggedUser } from '../../modules/Institution/InstitutionActions';

import withRouter from '../Router/WithRouter';
import Loader from '../Loader/Loader';
import UserLoginPage from '../../modules/User/pages/UserLoginPage/UserLoginPage';
import Error404Page from '../../modules/App/pages/error/Error404Page';
import InstitutionError from '../../modules/Institution/components/view/InstitutionError';

export default function authorization(allowedRoles) {
    return WrappedComponent => {
        class AuthorizationComponent extends Component {
            // componentWillMount() {
            //     if(!this.props.user) {
            //         this.context.router.push('/login');
            //     }
            // }
            //
            // componentWillUpdate(nextProps) {
            //     if(!nextProps.user) {
            //         this.context.router.push('/login');
            //     }
            // }

            isAuthenticated() {
                return this.props.user && allowedRoles.includes(this.props.user.role);
            }

            hasInstitutions() {
                return (this.props.user && this.props.user.institutions.includes('*')) || (this.props.institutions && this.props.institutions.length);
            }

            renderAlert() {
                if(this.props.user) {
                    return <Error404Page />;
                }
                return <UserLoginPage redirect={`${this.props.location.pathname}${this.props.location.search}`} />;
            }

            render() {
                // return <ComposedComponent {...this.props} />
                if(this.props.isMounted) {
                    if(this.isAuthenticated()) {
                        return (
                            <div>
                                {
                                    this.hasInstitutions()
                                    ? <WrappedComponent {...this.props} />
                                    : <InstitutionError />
                                }
                            </div>
                        );
                    }
                    return this.renderAlert();
                }
                return <Loader />;
            }
        }

        function mapStateToProps(store) {
            return {
                user: getLoggedUser(store),
                institutions: getInstitutionsForLoggedUser(store),
                isMounted: store.app.isMounted,
            };
        }

        AuthorizationComponent.propTypes = {
            dispatch: PropTypes.func.isRequired,
            location: PropTypes.object.isRequired,
            user: PropTypes.object,
            institutions: PropTypes.arrayOf(PropTypes.object),
            isMounted: PropTypes.bool.isRequired,
        };

        return connect(mapStateToProps)(withRouter(AuthorizationComponent));
    };
}
